// avstemming-payables-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'avdp.assess.notAssessed': 'Sin evaluar',
  'avdp.assess.noAction': 'OK – sin medidas',
  'avdp.assess.matchPayment': 'Debe conciliarse con un pago',
  'avdp.assess.wrongPosting': 'Contabilización errónea — debe corregirse',
  'avdp.assess.missingPosting': 'Contabilización pendiente',
  'avdp.assess.duplicate': 'Duplicado',
  'avdp.assess.creditNote': 'Se salda con una nota de crédito',
  'avdp.assess.awaitingDocs': 'A la espera de documentación',
  'avdp.assess.awaitingClient': 'A la espera del cliente',
  'avdp.assess.nextPeriod': 'Seguimiento en el próximo período',
  'avdp.quick.needsAssessment': 'Requiere evaluación',
  'avdp.quick.allOpen': 'Todas las abiertas',
  'avdp.quick.overdue': 'Vencidas',
  'avdp.quick.over90': 'Más de 90 días',
  'avdp.quick.negative': 'Saldos negativos',
  'avdp.quick.duplicates': 'Posibles duplicados',
  'avdp.quick.partlyPaid': 'Pagadas parcialmente',
  'avdp.quick.foreign': 'Partidas en moneda extranjera',
  'avdp.quick.missingDoc': 'Sin justificante',
  'avdp.quick.paidAfter': 'Pagadas después de la fecha del período',
  'avdp.quick.assessed': 'Evaluadas',
  'avdp.days.notRelevant': 'No aplica',
  'avdp.days.notDue': 'No vencida',
  'avdp.days.overdue': 'Vencida hace {days} días',
  'avdp.flags.none': 'Ninguna',
  'avdp.flags.more': '+{count} más',
  'avdp.nav.overview': 'Resumen',
  'avdp.nav.openItems': 'Partidas abiertas',
  'avdp.nav.suppliers': 'Proveedores',
  'avdp.nav.controls': 'Controles',
  'avdp.nav.conclusion': 'Conclusión',
  'avdp.nav.blocked': 'Bloqueado',
  'avdp.nav.ready': 'Listo',
  'avdp.toast.noAccount': 'El área no tiene ninguna cuenta de conciliación en este período.',
  'avdp.area.payables': 'Cuentas por pagar',
  'avdp.ledger.title': 'Auxiliar de proveedores y partidas abiertas',
  'avdp.filter.reset': 'Restablecer filtros',
  'avdp.filter.supplier': 'Proveedor: {name}',
  'avdp.filter.showAllSuppliers': 'Mostrar todos los proveedores',
  'avdp.filter.controlAccount': 'Cuenta de control: {account}',
  'avdp.filter.showAllAccounts': 'Mostrar todas las cuentas de control',
  'avdp.filter.ageGroup': 'Grupo de antigüedad: {label}',
  'avdp.filter.showAllAges': 'Mostrar todos los grupos de antigüedad',
  'avdp.col.supplier': 'Proveedor',
  'avdp.col.docNo': 'N.º doc.',
  'avdp.col.type': 'Tipo',
  'avdp.col.invoiceDate': 'Fecha de factura',
  'avdp.col.due': 'Vencimiento',
  'avdp.col.original': 'Original',
  'avdp.col.openAmount': 'Importe abierto',
  'avdp.col.currency': 'Moneda',
  'avdp.col.daysOverdue': 'Días de vencimiento',
  'avdp.col.flag': 'Aviso',
  'avdp.col.assessment': 'Evaluación',
  'avdp.row.viewAssessment': 'Ver evaluación',
  'avdp.row.assess': 'Evaluar',
  'avdp.ledger.noMatch': 'Ninguna partida de proveedores coincide con los filtros.',
  'avdp.ledger.noOpen': 'No hay partidas abiertas de proveedores en este período. Si el cliente no tiene facturas de proveedores pendientes de pago, no hay auxiliar que conciliar.',
  'avdp.header.controlAccount': 'Cuenta de control {accounts}',
  'avdp.header.responsible': 'Responsable: {name}',
  'avdp.header.title': '{area} – libro mayor frente al auxiliar',
  'avdp.header.noControlAccount': 'Ninguna cuenta de control en el área',
  'avdp.header.matches': 'El libro mayor y el auxiliar cuadran',
  'avdp.header.differs': 'El libro mayor y el auxiliar no coinciden',
  'avdp.header.noSubledger': 'Ninguna cuenta de control con auxiliar',
  'avdp.header.needsAssessment': '{count} partidas del auxiliar requieren evaluación antes de poder enviar la conciliación a revisión.',
  'avdp.header.allAssessed': 'No quedan partidas del auxiliar por evaluar.',
  'avdp.balance.title': 'Conciliación automática de saldos',
  'avdp.balance.computedAt': 'El auxiliar está calculado a {date}',
  'avdp.balance.booked': 'Saldo contabilizado, cuenta de control con auxiliar',
  'avdp.balance.ledgerAt': 'Auxiliar de proveedores a {date}',
  'avdp.balance.difference': 'Diferencia',
  'avdp.balance.noSubledger': 'Ninguna de las cuentas del área es la cuenta de proveedores en la que la app contabiliza las compras ({account}). Por tanto, no hay auxiliar con el que comparar el saldo y la diferencia debe explicarse en la propia cuenta.',
  'avdp.balance.mismatch': 'La cuenta de control no cuadra con el auxiliar. La diferencia debe explicarse antes de poder conciliar el área — consulta los asientos directos más abajo.',
  'avdp.balance.opening': 'Saldo del período anterior',
  'avdp.balance.change': 'Variación en el período',
  'avdp.balance.openInvoices': 'Facturas abiertas',
  'avdp.balance.overdueAmount': 'Importe vencido',
  'avdp.balance.totalItems': 'Total de partidas en el control',
  'avdp.balance.suppliersWithBalance': 'Proveedores con saldo',
  'avdp.accounts.title': 'Cuentas de control',
  'avdp.accounts.empty': 'No hay cuentas de balance vinculadas a cuentas por pagar en este período. Sin una cuenta de control, no hay saldo contabilizado con el que comparar el auxiliar.',
  'avdp.accounts.colAccount': 'Cuenta de control',
  'avdp.accounts.colBooked': 'Saldo contabilizado',
  'avdp.accounts.colSubledger': 'Saldo del auxiliar',
  'avdp.accounts.colDifference': 'Diferencia',
  'avdp.accounts.colStatus': 'Estado',
  'avdp.accounts.noSubledger': 'Sin auxiliar',
  'avdp.accounts.deviation': 'Desviación',
  'avdp.accounts.matches': 'Cuadra',
  'avdp.accounts.open': 'Abrir cuenta',
  'avdp.card.ledgerVsSubledger': 'Libro mayor frente al auxiliar',
  'avdp.card.ledgerVsSubledgerHint': 'Saldo contabilizado comparado con la suma de las partidas abiertas al cierre del período.',
  'avdp.card.old': 'Partidas antiguas de más de 90 días',
  'avdp.card.oldHint': 'Partidas abiertas vencidas hace más de 90 días.',
  'avdp.card.negative': 'Saldos negativos de proveedores',
  'avdp.card.negativeHint': 'Facturas pagadas por más de su importe. El proveedor le debe dinero a la empresa.',
  'avdp.card.duplicates': 'Posibles duplicados',
  'avdp.card.affected': '{count} partidas afectadas',
  'avdp.card.duplicatesHint': 'Mismo proveedor, misma fecha de factura y mismo importe.',
  'avdp.card.paymentsNoInvoice': 'Pagos sin factura',
  'avdp.card.paymentsNoInvoiceHint': 'Líneas de débito en la cuenta de control sin una factura de proveedor detrás. Consulta los asientos directos más abajo.',
  'avdp.card.partlyPaid': 'Pagada parcialmente, pero aún abierta',
  'avdp.card.partlyPaidHint': 'Partidas con un pago registrado que siguen abiertas.',
  'avdp.card.missingDoc': 'Justificantes que faltan',
  'avdp.card.missingDocHint': 'Partidas abiertas sin justificante guardado.',
  'avdp.card.overdue30': 'Partidas vencidas hace más de 30 días',
  'avdp.card.overdue30Hint': 'Partidas abiertas vencidas hace entre 31 y 90 días.',
  'avdp.card.foreign': 'Partidas en moneda extranjera por revisar',
  'avdp.card.foreignHint': 'Facturas abiertas en una moneda distinta de NOK. Debe comprobarse el tipo de cambio en la fecha de cierre del balance.',
  'avdp.card.paidAfter': 'Pagadas después de la fecha del período',
  'avdp.card.paidAfterHint': 'Partidas abiertas a la fecha del período que se pagaron después — normalmente documentación favorable.',
  'avdp.card.direct': 'Contabilizado directamente en la cuenta de control',
  'avdp.card.directHint': 'Líneas del libro mayor en las cuentas de control que no proceden de una factura de proveedor ni de un pago.',
  'avdp.card.title': 'Tarjeta de control',
  'avdp.card.checksRun': 'Controles automáticos ejecutados: {count} de {total}',
  'avdp.card.findings': 'Controles con hallazgos: {count}',
  'avdp.card.manual': 'Partidas que requieren evaluación manual: {count}',
  'avdp.card.hide': 'Ocultar',
  'avdp.card.showAll': 'Mostrar todos los controles automáticos',
  'avdp.card.activeFilter': 'Filtro activo: {label}',
  'avdp.card.itemsCount': '{count} partidas',
  'avdp.card.removeFilter': 'Quitar filtro',
  'avdp.aging.title': 'Distribución por antigüedad (días de vencimiento)',
  'avdp.aging.empty': 'No hay partidas abiertas de proveedores al cierre del período — no hay nada que distribuir por antigüedad.',
  'avdp.aging.note': 'Calculada desde la fecha de vencimiento, no desde la fecha de la factura.',
  'avdp.aging.colAge': 'Antigüedad',
  'avdp.aging.colCount': 'Número de partidas',
  'avdp.aging.colAmount': 'Importe abierto',
  'avdp.aging.colShare': 'Proporción',
  'avdp.aging.needsAssessment': 'Requiere evaluación',
  'avdp.aging.total': 'Total de partidas abiertas',
  'avdp.suppliers.emptyTitle': 'Proveedores con saldo abierto',
  'avdp.suppliers.empty': 'Ningún proveedor tiene saldo abierto al cierre del período. La concentración se mide con las partidas abiertas, así que sin ellas no hay distribución que evaluar.',
  'avdp.suppliers.title': 'Proveedores con partidas abiertas',
  'avdp.suppliers.topFive': 'Los cinco mayores suponen el {share} % del saldo',
  'avdp.suppliers.colSupplier': 'Proveedor',
  'avdp.suppliers.colItems': 'Partidas abiertas',
  'avdp.suppliers.colAmount': 'Importe abierto',
  'avdp.suppliers.colOverdue': 'De ello vencido',
  'avdp.suppliers.colOldest': 'Partida más antigua',
  'avdp.suppliers.colShare': 'Proporción',
  'avdp.suppliers.negative': 'Saldo negativo',
  'avdp.suppliers.days': '{days} días',
  'avdp.direct.title': 'Asientos directos en la cuenta de control',
  'avdp.direct.empty': 'Ninguna línea del libro mayor en las cuentas de control procede de algo distinto de una factura o un pago. El control se ha ejecutado — no encontró nada.',
  'avdp.direct.note': 'Asientos del período que no proceden de una factura de proveedor ni del pago de una. Una línea de débito sin factura detrás es un pago que ninguna factura respalda.',
  'avdp.direct.colDate': 'Fecha',
  'avdp.direct.colVoucher': 'Justificante',
  'avdp.direct.colText': 'Texto',
  'avdp.direct.colAccount': 'Cuenta',
  'avdp.direct.colType': 'Tipo',
  'avdp.direct.colAmount': 'Importe',
  'avdp.direct.paymentNoInvoice': 'Pago sin factura',
  'avdp.direct.debtNoInvoice': 'Deuda sin factura',
  'avdp.checks.title': 'Controles automáticos',
  'avdp.checks.note': 'Los controles no marcan nada en la lista de comprobación profesional. Indican qué debería haber revisado quien marca los puntos.',
  'avdp.checks.colCheck': 'Control',
  'avdp.checks.colRun': 'Ejecución',
  'avdp.checks.colResult': 'Resultado',
  'avdp.checks.run': 'Ejecutado',
  'avdp.checks.findingsCount': '{count} hallazgos',
  'avdp.checks.none': 'Sin hallazgos',
  'avdp.derived.old': 'Todas las partidas antiguas relevantes están evaluadas',
  'avdp.derived.negative': 'Los saldos negativos de proveedores están explicados',
  'avdp.derived.duplicate': 'Los posibles duplicados están evaluados',
  'avdp.derived.partlyPaid': 'Las partidas pagadas parcialmente están analizadas',
  'avdp.derived.foreign': 'Las partidas en moneda extranjera están comprobadas',
  'avdp.derived.missingDoc': 'Las partidas sin justificante están tratadas',
  'avdp.blocker.one': '{count} partida del auxiliar requiere evaluación',
  'avdp.blocker.many': '{count} partidas del auxiliar requieren evaluación',
  'avdp.blocker.oneCritical': '{count} partida del auxiliar requiere evaluación, de las cuales {critical} críticas',
  'avdp.blocker.manyCritical': '{count} partidas del auxiliar requieren evaluación, de las cuales {critical} críticas',
  'avdp.blocker.diff': '{amount} de la diferencia con el auxiliar está sin explicar',
  'avdp.blocker.pointOne': 'Queda {count} punto de control',
  'avdp.blocker.pointMany': 'Quedan {count} puntos de control',
  'avdp.check.title': 'Lista de comprobación profesional',
  'avdp.check.titleReadOnly': 'Lista de comprobación profesional (de quien la realiza, solo lectura)',
  'avdp.check.noPoints': 'No hay puntos de control definidos para las cuentas por pagar en este período.',
  'avdp.check.scope': 'Los puntos se aplican a toda el área. Una marca se guarda en todas las cuentas de control del período.',
  'avdp.check.groupItems': 'Partidas que requieren tratamiento',
  'avdp.check.groupAssessments': 'Evaluaciones profesionales generales',
  'avdp.check.groupReady': 'Preparación',
  'avdp.check.count': '{done} de {total}',
  'avdp.check.processed': '{done} de {total} tratadas',
  'avdp.check.notApplicable': 'No aplica en este período',
  'avdp.check.followsAssessments': 'Se deduce de las evaluaciones',
  'avdp.check.performedBy': 'Realizado por {name}',
  'avdp.check.completed': '{done} de {total} puntos de control completados',
  'avdp.concl.title': 'Conclusión y aprobación',
  'avdp.concl.placeholder': '¿Qué muestra la revisión de las cuentas por pagar de este período?',
  'avdp.concl.savedAs': 'Se guarda como justificación del punto de control «{label}».',
  'avdp.concl.remainingRisk': 'Riesgo pendiente',
  'avdp.concl.noRisk': 'No queda nada que impida enviar el área a revisión.',
  'avdp.concl.followUp': 'Seguimiento del próximo período',
  'avdp.concl.noFollowUp': 'Ninguna evaluación está marcada para seguimiento en el próximo período.',
  'avdp.concl.followed': 'En seguimiento',
  'avdp.concl.measure': 'Medida: {text}',
  'avdp.concl.noMeasure': 'Sin medidas anotadas',
  'avdp.concl.deadline': 'Plazo {date}',
  'avdp.concl.openAssessment': 'Abrir evaluación',
  'avdp.concl.send': 'Enviar el área a revisión',
  'avdp.concl.oneLeft': 'Queda una cosa antes de poder enviar el área.',
  'avdp.concl.manyLeft': 'Quedan {count} cosas antes de poder enviar el área.',
  'avdp.drawer.reasonOverdue': 'La partida lleva {days} días vencida',
  'avdp.drawer.reasonDuplicate': 'Posible duplicado de {ids}',
  'avdp.drawer.reasonOverpaid': 'Pagado {paid} frente a un justificante de {gross}',
  'avdp.drawer.reasonPartlyPaid': 'Pagada parcialmente con {paid} en el período',
  'avdp.drawer.reasonPaidAfter': 'Pagado {amount}, después de la fecha del período',
  'avdp.drawer.reasonPaidAfterOn': 'Pagado {amount} el {date}, después de la fecha del período',
  'avdp.drawer.reasonCurrencyRate': 'Contabilizado en {currency} a tipo de cambio {rate}',
  'avdp.drawer.reasonCurrencyNoRate': 'Contabilizado en {currency} sin tipo de cambio guardado',
  'avdp.drawer.reasonNoDoc': 'No hay ningún justificante guardado en la compra',
  'avdp.drawer.unknownOrgNo': 'N.º de organización desconocido',
  'avdp.drawer.close': 'Cerrar',
  'avdp.drawer.invoiceDate': 'Fecha de factura',
  'avdp.drawer.dueDate': 'Fecha de vencimiento',
  'avdp.drawer.daysOverdue': 'Días de vencimiento',
  'avdp.drawer.originalAmount': 'Importe original',
  'avdp.drawer.openAtEnd': 'Abierto al cierre del período',
  'avdp.drawer.paidInPeriod': 'Pagado en el período',
  'avdp.drawer.paidAfterDate': 'Pagado después de la fecha del período',
  'avdp.drawer.currencyRate': 'Moneda / tipo de cambio',
  'avdp.drawer.currency': 'Moneda',
  'avdp.drawer.controlAccount': 'Cuenta de control',
  'avdp.drawer.voucher': 'Justificante',
  'avdp.drawer.stored': 'Guardado',
  'avdp.drawer.missing': 'Falta',
  'avdp.drawer.assessment': 'Evaluación',
  'avdp.drawer.justification': 'Justificación',
  'avdp.drawer.justificationRequired': 'Justificación (obligatoria)',
  'avdp.drawer.justificationPlaceholder': '¿Qué muestra la revisión de esta partida?',
  'avdp.drawer.measure': 'Medida',
  'avdp.drawer.measurePlaceholder': 'P. ej. Pedir al proveedor que abone el duplicado',
  'avdp.drawer.followUpDeadline': 'Plazo de seguimiento',
  'avdp.drawer.markFollowUp': 'Marcar para seguimiento en el próximo período',
  'avdp.drawer.linkedDocOne': '{count} documento está vinculado a la cuenta de control en este período.',
  'avdp.drawer.linkedDocMany': '{count} documentos están vinculados a la cuenta de control en este período.',
  'avdp.drawer.needsJustification': 'Esta evaluación requiere una justificación.',
  'avdp.drawer.save': 'Guardar evaluación',
  'avdp.drawer.requestDocs': 'Pedir documentación al cliente',
});
